const constants = {
  gtm: "GTM-WTLQLDX",
  appApiEndpoint: "https://app-api.live-2022.dusk.app/v1",
};

export default constants;
